export default "__VITE_ASSET__CToWjo_f__"